import imagesPillarPages from '../imagesPillarPages';

export default {
  checkmarkColumnsData: [
    {
      title: 'Provenance Tracking',
      subtitle:
        'Customers are more than ever eager to verify the provenance of the products they buy. Blockchain is an answer both for suppliers and final customers providing proper documentation of the origin of products ranging from food to luxury.'
    },
    {
      title: 'Supply Chains Management',
      subtitle:
        'Supply chains are complex with plenty of parties involved and dozens of documents passing from hand to hand. Blockchain helps to streamline, speed-up, and reduce mistakes or miscommunication risks in this specific industry.'
    },
    {
      title: 'Cross-border payments',
      subtitle:
        'Blockchain-based cross-border payments can help B2B relationships to lower transaction costs, reduce payments from 3-5 days to real-time, and finally increase transparency and security of payments execution.'
    },
    {
      title: 'Cryptocurrency Exchange',
      subtitle:
        'The market of crypto is still at an early stage. There is plenty of room for more great platforms and services handling bitcoin, ethereum as well as other coin management and trade systems.'
    }
  ],

  benefitsOfBlockchain: [
    'Get an objective, immutable history or log of data via distributed ledger',
    'Build up trust and reduce conflicting incentives by applying smart contracts',
    'Bring transparency to supply chains that involve plenty of parties and shared documents',
    'Use cryptography for confidential information and authentication',
    'Create an environment that automatically executes consensus agreements and governance.',
    'Reduce low value middle man work'
  ],
  telecomSectionData1: {
    title: 'Get top blockchain engineers for your project',
    description: [
      'Choosing the right technology partner for your business is not easy.',
      'At Ulam Labs, we assist you in each step of the blockchain software development, from the idea, through planning, across the development stage, till the release.',
      'With expertise in multiple blockchain platforms, including Ethereum, Hyperledger, Corda, or Quorum, we build scalable and robust custom blockchain solutions for enterprises and startups.'
    ],
    list: [
      'since 2012 on the market',
      '20+ successful projects',
      'Startups and SME oriented',
      'All range of industries: Fintech, Telco, E-commerce, and more...'
    ],
    btnText: "Let's work together"
  },
  telecomSectionData2: {
    title:
      'Blockchain applications and industries we serve using distributed ledger',
    description: [
      'Blockchain technology is widespread across various industries. Blockchain services are a perfect fit for companies looking for secure information exchange and data sharing, decentralized networks of IoT devices, fast global payments with minimal transaction costs.',
      'Almost all industries can benefit from blockchain adoption. Especially those that involve many parties handling the same sets of information, which are the most prone to the risk of data loss and/or uncontrolled modification.',
      'With the use of distributed ledger, we can solve many real industry problems. Our blockchain developers are passionate about new technologies and love to work on innovative products! Contact us and check what we could do together!'
    ],
    list: [
      'fintech',
      'banking',
      'finance',
      'insurance',
      'supply chain',
      'retail',
      'healthcare',
      'government and administration',
      'real estate'
    ],
    listHeader: 'Blockchain technology is well suited for:',
    btnText: 'Get a free quote'
  },
  carouselImages: [
    {
      src: 'pages/Corda-logo.png',
      alt: 'corda',
      title: 'corda'
    },
    {
      src: 'pages/Ethereum-logo.png',
      alt: 'ethereum',
      title: 'ethereum'
    },
    {
      src: 'pages/Hyperledger-logo.png',
      alt: 'hyperledger',
      title: 'hyperledger'
    },
    {
      src: 'pages/quorum-logo.png',
      alt: 'quorum',
      title: 'quorum'
    },
    { src: 'pages/chain-logo.png', alt: 'chain', title: 'chain' }
  ],
  headingText: {
    title:
      'Build up trust and transparency for your business with blockchain solutions',
    description:
      'Blockchain technology is the future for companies from various sectors: healthcare, finance, real estate, retail, logistics, and many more. Our team of blockchain engineers will support the full range of your software development needs. Engage the most disruptive technology of recent years to support your business. Create secure decentralized databases to manage transactions or store data without compromising privacy.',
    img: imagesPillarPages.blockchainIconSVG
  },
  softwaresText: {
    title: 'Decentralizing businesses',
    subtitle:
      'Leverage blockchain in your company. Our DLT experts will help you get the most of this trending technology.',
    description:
      'All the great software we create is in accordance with a standardized workflow and Scrum methodology.',
    businessList: [
      {
        icon: imagesPillarPages.frontendSVG,
        title: 'Dapps development',
        description: `Create customized and feature-rich decentralized applications with us. We develop secure and seamless infrastructure for supply chain, finance, trade, gaming, and legal business.`
      },
      {
        icon: imagesPillarPages.enterpriseSVG,
        title: 'Enterprise permissioned blockchains',
        description: `Secure your business data and automate operations with private distributed ledgers that are lightning-fast and can be used only by identified participants.`
      },
      {
        icon: imagesPillarPages.paperSVG,
        title: 'Smart Contracts',
        description: `Automate processes, transactions and agreements, limit third-party intervention or simply reduce costs by using smart contracts developed by our team.`
      },
      {
        icon: imagesPillarPages.chainSVG,
        title: 'Oracles development',
        description: `Build bridges between blockchain and real-world data to ensure that blockchain entries can be trusted and used in your business automation.`
      }
    ]
  },
  testimonialText: {
    customTitle:
      'What our clients say about our blockchain development services?',
    customSubtitle:
      'Founders, SEOs and top managers from all over the world value our service especially for smooth communication, expertise and timely product delivery. Read custom opinions which prove that we are perfect technology partner for you as well.'
  },
  checkmarkText: {
    title: 'Prominent blockchain applications',
    description:
      'Blockchain technology serves as a fuel for emerging applications across finance, business, government, and many other industries. With its ability to create more transparency and fairness while also saving businesses time and money, it is impacting a variety of sectors in ways that range from how contracts are enforced to making supply chains work more efficiently.'
  }
};
